import React, { useCallback, useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import Summary from "./partials/Summary";
import { useCookies } from "react-cookie";
import { getChargeStatisticSummary } from "../../../controller/api/statistic/charge";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    from: new Date(),
    to: new Date(),
    phone: '',
  },
  data: {
    list: [],
  },
  summary: {
    total: '0',
    fee: '0',
    count: 0
  },
  filterPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...action.payload
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          list: action.payload.list
        },
        summary: {
          total: action.payload.total,
          fee: action.payload.fee,
          count: action.payload.count
        }
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['lottmekong'])

  const getAllFunc = useCallback(async () => {
    let phone = state.filter.phone

    const response = await getChargeStatisticSummary(cookies.lottmekong, {
      from: state.filter.from,
      to: state.filter.to,
      phone: phone
    })

    if (response) {
      dispatch({
        type: 'UPDATE_DATA',
        payload: {
          list: response.data,
          count: response.count,
          total: response.total,
          fee: response.fee,
        }
      })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.phone])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc, state.filterPressCount])

  useEffect(() => {
    document.title = "Nạp tiền"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      <Summary />

      <br />

      <Table />
    </Context.Provider>
  );
};
